import { BaseMapper } from '@ps/utils';
import { SupplierGroupTemplateDto } from '../dtos/supplier-group-template.dto';
import { SupplierGroupTemplate } from '../../models/supplier-group-template.model';

export class SupplierGroupTemplateMapper extends BaseMapper<
  SupplierGroupTemplateDto,
  SupplierGroupTemplate
> {
  public fromDto(dto: SupplierGroupTemplateDto): SupplierGroupTemplate {
    return {
      id: dto.id,
      groupName: dto.groupName,
      allocation: dto.allocation,
      isCustomAllocation: dto.is_custom_allocation,
      members: dto.suppliers.map((supplier) => ({
        id: supplier.id,
        name: supplier.name,
        allocation: supplier.allocation ?? null,
      })),
    };
  }
}
